export const SONL_LINK =
  "https://covertree.com/wp-content/uploads/2026/02/No-Loss.pdf";
export const SPP_GUIDE_LINK =
  "https://drive.google.com/file/d/17GuuaQop9JgPelfdA8hOtbanCW__wRfs/view";
